var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _g3, _g4, _g5, _path9, _path10, _path11, _path12, _path13, _path14, _g6, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAduvetcoveronepillow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "106.74pt",
    height: "58.872pt",
    viewBox: "0 0 106.74 58.872",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m138 246.12h13.457v9.2969h-13.457z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m137.92 246.12h13.535v9.2969h-13.535z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m138 246.12h13.457v9.2969h-13.457z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m137.92 246.12h13.535v9.2969h-13.535z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m102.87 233.57h48.977v22.57h-48.977z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.982 -233.44)",
    fill: "none",
    stroke: "#6b645b",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m559.88 3273.6 316.84-126.6s34.453-14.883 69.219 1.0156l583.36 266.56",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 3.864
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m527.11 3301.4v-107.19c0.89844-8.2422 9.375-17.734 32.773-27.812l316.88-130.23-0.0391-0.1172s36.953-12.617 71.719 3.2812"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1529.3 3414.6c57.227 26.133 4.5312 45.664 4.5312 45.664l-318.32 102.15c-33.555 11.953-60.508 0.2734-60.508 0.2734l-600.7-233.44s-64.883-25.234 5.625-55.625"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1555.8 3440.7v-101.25c-0.8984-6.6797-7.8516-15.703-26.562-24.258l-583.28-277.03"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m55.998 7.0368c-33.441 10.16-46.984 18.477-47.805 18.977-0.02344 0.0156-0.04297 0.0234-0.06641 0.0391-0.44922 0.24219-5.6211 3.1602-7.7891 9.4414-0.25391 0.73438 0.12109 1.5703 0.85938 1.8203 0.0078 4e-3 0.01953 8e-3 0.03125 0.0117 0.95703 0.39844 20.941 1.7695 41.219 18.77 0 0 0.13672 0.48047 1.9023-0.0117 0 0 24.547-20.875 54.355-27.07 0 0 1.3633 0.46875 1.2188-0.76562 0 0-1.6953-14.184-43.516-21.215",
    fill: "#ddd9ce"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m55.998 7.0368c-33.441 10.16-46.984 18.477-47.805 18.977-0.023437 0.01562-0.042969 0.02344-0.066406 0.03906-0.44922 0.24219-5.6211 3.1602-7.7891 9.4414-0.25391 0.73438 0.12109 1.5703 0.85938 1.8203 0.00781 0.0039 0.019531 0.0078 0.03125 0.01172 0.95703 0.39844 20.941 1.7695 41.219 18.77 0 0 0.13672 0.48047 1.9023-0.01172 0 0 24.547-20.875 54.355-27.07 0 0 1.3633 0.46875 1.2188-0.76562 0 0-1.6953-14.184-43.516-21.215z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m56.008 7.1668c-34.297 10.426-47.84 19-47.84 19s-5.832 3.2305-7.8477 9.5117c-0.17578 0.55078-0.01953 1.1758 0.4375 1.5273 0.12891 0.10156 0.28516 0.1875 0.47656 0.25 0.96094 0.40234 20.945 1.7734 41.219 18.773 0 0 0.14062 0.47656 1.9062-0.0156 0 0 25.027-20.941 54.84-27.137 0 0 0.8789 0.53516 0.73437-0.69531 0 0-2.1133-14.18-43.52-21.215",
    fill: "#ddd9ce"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m56.008 7.1668c-34.297 10.426-47.84 19-47.84 19s-5.832 3.2305-7.8477 9.5117c-0.17578 0.55078-0.019531 1.1758 0.4375 1.5273 0.12891 0.10156 0.28516 0.1875 0.47656 0.25 0.96094 0.40234 20.945 1.7734 41.219 18.773 0 0 0.14062 0.47656 1.9062-0.01562 0 0 25.027-20.941 54.84-27.137 0 0 0.8789 0.53516 0.73438-0.69531 0 0-2.1133-14.18-43.52-21.215z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m102.25 12.807s-3.1328 4.8203-10.051 9.0156l-3.0508-2.4297s8.6523-6.5078 9.1836-6.5547c0.52734-0.0469 3.918-0.0312 3.918-0.0312",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m102.25 12.807s-3.1328 4.8203-10.051 9.0156l-3.0508-2.4297s8.6523-6.5078 9.1836-6.5547c0.52734-0.04688 3.918-0.03125 3.918-0.03125z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m102.25 12.807s-3.1328 4.8203-10.051 9.0156l-3.0508-2.4297s8.6523-6.5078 9.1836-6.5547c0.52734-0.0469 3.918-0.0312 3.918-0.0312",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m102.25 12.807s-3.1328 4.8203-10.051 9.0156l-3.0508-2.4297s8.6523-6.5078 9.1836-6.5547c0.52734-0.04688 3.918-0.03125 3.918-0.03125z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.982 -233.44)",
    clipPath: "url(#clip-6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m151.23 246.25s-3.1328 4.8203-10.051 9.0156l-3.0508-2.4297s8.6523-6.5078 9.1836-6.5547c0.52734-0.0469 3.918-0.0312 3.918-0.0312",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.982 -233.44)",
    clipPath: "url(#clip-7)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1512.3 3490.7s-31.328-48.203-100.51-90.156l-30.508 24.297s86.523 65.078 91.836 65.547c5.2734 0.4688 39.18 0.3125 39.18 0.3125z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.982 -233.44)",
    clipPath: "url(#clip-8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m151.23 246.25s-3.1328 4.8203-10.051 9.0156l-3.0508-2.4297s8.6523-6.5078 9.1836-6.5547c0.52734-0.0469 3.918-0.0312 3.918-0.0312",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.982 -233.44)",
    clipPath: "url(#clip-9)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1512.3 3490.7s-31.328-48.203-100.51-90.156l-30.508 24.297s86.523 65.078 91.836 65.547c5.2734 0.4688 39.18 0.3125 39.18 0.3125z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m102.25 12.807s-3.1328 4.8203-10.051 9.0156l-3.0508-2.4297s8.6523-6.5078 9.1836-6.5547c0.52734-0.0469 3.918-0.0312 3.918-0.0312",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m102.25 12.807s-3.1328 4.8203-10.051 9.0156l-3.0508-2.4297s8.6523-6.5078 9.1836-6.5547c0.52734-0.04688 3.918-0.03125 3.918-0.03125z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m102.25 12.807s-3.1328 4.8203-10.051 9.0156l-3.0508-2.4297s8.6523-6.5078 9.1836-6.5547c0.52734-0.0469 3.918-0.0312 3.918-0.0312",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m102.25 12.807s-3.1328 4.8203-10.051 9.0156l-3.0508-2.4297s8.6523-6.5078 9.1836-6.5547c0.52734-0.04688 3.918-0.03125 3.918-0.03125z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m92.208 22.077 1.1016-1.8867c0.21875-0.37109 0.53906-0.74219 0.9375-1.0938l4.082-3.5508c0.40234-0.34766 0.87891-0.66797 1.4062-0.94141l2.668-1.3945c0.39453-0.20312 0.44531-0.53516 0.0898-0.59766l-3.5625-0.60938-4e-3 4e-3 -30.75-10.457-2.6797-1.375c-0.26953-0.13672-0.80469 0.0391-0.96875 0.32031l-1.043 1.7852c-0.21875 0.37109-0.53516 0.74219-0.9375 1.0898l-4.2891 3.7344c-0.39844 0.34766-0.87891 0.66797-1.4062 0.94141l-2.5195 1.3164c-0.39453 0.20703-0.44531 0.53906-0.0898 0.59766l2.9766 0.50781c0.18359 0.0312 0.35938 0.0742 0.52344 0.125l30.805 10.473c0.16406 0.0508 0.3125 0.11328 0.45312 0.18359l2.2422 1.1484c0.26562 0.13672 0.80078-0.0391 0.96484-0.32031",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m92.208 22.077 1.1016-1.8867c0.21875-0.37109 0.53906-0.74219 0.9375-1.0938l4.082-3.5508c0.40234-0.34766 0.87891-0.66797 1.4062-0.94141l2.668-1.3945c0.39453-0.20312 0.44531-0.53516 0.0898-0.59766l-3.5625-0.60938-0.0039 0.0039-30.75-10.457-2.6797-1.375c-0.26953-0.13672-0.80469 0.03906-0.96875 0.32031l-1.043 1.7852c-0.21875 0.37109-0.53516 0.74219-0.9375 1.0898l-4.2891 3.7344c-0.39844 0.34766-0.87891 0.66797-1.4062 0.94141l-2.5195 1.3164c-0.39453 0.20703-0.44531 0.53906-0.08985 0.59766l2.9766 0.50781c0.18359 0.03125 0.35938 0.07422 0.52344 0.125l30.805 10.473c0.16406 0.05078 0.3125 0.11328 0.45312 0.18359l2.2422 1.1484c0.26562 0.13672 0.80078-0.03907 0.96484-0.32031z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.982 -233.44)",
    clipPath: "url(#clip-10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m141.2 255.65 1.1016-1.8906c0.21875-0.37109 0.53906-0.74219 0.9375-1.0938l4.082-3.5508c0.40234-0.34766 0.87891-0.66797 1.4062-0.94141l2.668-1.3906c0.39453-0.20703 0.44531-0.53906 0.0898-0.60156l-3.5664-0.60938v4e-3l-30.75-10.457-2.6836-1.375c-0.26562-0.13672-0.80078 0.043-0.96484 0.32031l-1.043 1.7852c-0.21875 0.37109-0.53516 0.74219-0.9375 1.0938l-4.2891 3.7305c-0.39844 0.34766-0.87891 0.66797-1.4062 0.94531l-2.5195 1.3125c-0.39453 0.20703-0.44141 0.53906-0.0898 0.59766l2.9766 0.50781c0.18359 0.0352 0.35938 0.0742 0.52344 0.125l30.805 10.473c0.16406 0.0547 0.3125 0.11328 0.45312 0.1875l2.2422 1.1445c0.26562 0.14062 0.80078-0.0391 0.96484-0.31641",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.1 0 0 -.1 0 595.32)",
    d: "m1412 3396.7 11.016 18.906c2.1875 3.7109 5.3906 7.4219 9.375 10.938l40.82 35.508c4.0234 3.4766 8.7891 6.6797 14.062 9.4141l26.68 13.906c3.9453 2.0703 4.4531 5.3906 0.8984 6.0156l-35.664 6.0938v-0.039l-307.5 104.57-26.836 13.75c-2.6562 1.3672-8.0078-0.4297-9.6484-3.2031l-10.43-17.852c-2.1875-3.7109-5.3516-7.4219-9.375-10.938l-42.891-37.305c-3.9844-3.4766-8.7891-6.6797-14.062-9.4531l-25.195-13.125c-3.9453-2.0703-4.4141-5.3906-0.8984-5.9766l29.766-5.0781c1.8359-0.3515 3.5938-0.7422 5.2344-1.25l308.05-104.73c1.6406-0.5468 3.125-1.1328 4.5312-1.875l22.422-11.445c2.6562-1.4062 8.0078 0.3907 9.6484 3.1641z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m92.228 22.197 1.1016-1.8867c0.21875-0.37109 0.53516-0.74219 0.9375-1.0938l4.082-3.5508c0.39844-0.34766 0.87891-0.66797 1.4062-0.94141l2.6641-1.3945c0.39453-0.20312 0.44531-0.53516 0.0898-0.59766l-3.5625-0.60938v4e-3l-30.754-10.457h4e-3l-2.6836-1.375c-0.26562-0.13672-0.80469 0.0391-0.96875 0.32031l-1.0391 1.7852c-0.21875 0.37109-0.53906 0.74219-0.9375 1.0898l-4.2891 3.7344c-0.40234 0.34766-0.87891 0.66797-1.4062 0.94141l-2.5195 1.3164c-0.39453 0.20703-0.44531 0.53906-0.0898 0.59766l2.9766 0.50781c0.18359 0.0312 0.35547 0.0742 0.51953 0.125l30.805 10.473c0.16406 0.0508 0.31641 0.11328 0.45312 0.18359l2.2422 1.1484c0.26562 0.13672 0.80469-0.0391 0.96875-0.32031",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m92.228 22.197 1.1016-1.8867c0.21875-0.37109 0.53516-0.74219 0.9375-1.0938l4.082-3.5508c0.39844-0.34766 0.87891-0.66797 1.4062-0.94141l2.6641-1.3945c0.39453-0.20312 0.44531-0.53516 0.0898-0.59766l-3.5625-0.60938v0.0039l-30.754-10.457h0.0039l-2.6836-1.375c-0.26562-0.13672-0.80469 0.03906-0.96875 0.32031l-1.0391 1.7852c-0.21875 0.37109-0.53906 0.74219-0.9375 1.0898l-4.2891 3.7344c-0.40234 0.34766-0.87891 0.66797-1.4062 0.94141l-2.5195 1.3164c-0.39453 0.20703-0.44531 0.53906-0.08984 0.59766l2.9766 0.50781c0.18359 0.03125 0.35547 0.07422 0.51953 0.125l30.805 10.473c0.16406 0.05078 0.31641 0.11328 0.45312 0.18359l2.2422 1.1484c0.26562 0.13672 0.80469-0.03907 0.96875-0.32031z",
    fill: "none",
    stroke: "#6b645b",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAduvetcoveronepillow);
export default __webpack_public_path__ + "static/media/aduvetcoveronepillow.69d85c201e5150f726705722d7c11f3b.svg";
export { ForwardRef as ReactComponent };